export default "__VITE_ASSET__B7TD_tnD__"